// This is the repo name on github.

export const GITHUB_REPO_NAME = "website";
